import { extractPdfTier1 } from './tier1-text.js';
import { parsePdfTier2 } from './tier2/index.js';
export { configurePdfWorker, extractPdfTier1 } from './tier1-text.js';
export { parsePdfTier2 } from './tier2/index.js';
/**
 * Smart PDF parser: try Tier 2 (structured) first, fall back to Tier 1 (raw text)
 * if Tier 2 throws or produces empty markdown.
 *
 * Tier 2 markdown is structurally richer (headings / lists / emphasis / tables / multi-column),
 * but Tier 1's plain text is a robust safety net for malformed PDFs that confuse Tier 2.
 */
export async function extractPdf(file) {
    const buffer = await file.arrayBuffer();
    try {
        const tier2 = await parsePdfTier2(buffer);
        if (tier2.markdown.trim().length > 0) {
            return tier2;
        }
        const tier1 = await extractPdfTier1(file);
        return {
            ...tier1,
            meta: {
                ...tier1.meta,
                attemptedTier: 'tier2',
                fallbackReason: 'tier2 produced empty markdown',
            },
        };
    }
    catch (err) {
        const tier1 = await extractPdfTier1(file);
        return {
            ...tier1,
            meta: {
                ...tier1.meta,
                attemptedTier: 'tier2',
                fallbackReason: `tier2 threw: ${err.message}`,
            },
        };
    }
}
//# sourceMappingURL=index.js.map